import Vue from 'vue';
import Router from 'vue-router';
import { getItemFromStore } from '@/utils/helpers';
import { isEmpty } from 'lodash';
import { ROUTE_NAME, resolveClientVersion } from '@/utils/constant';
import store from '@/store';

Vue.use(Router);

const lazyLoad = (view: any) => {
  return () => import(`@/pages/${view}.vue`);
};

const routes = [
  {
    path: '/launch.html',
    name: ROUTE_NAME.launch,
    alias: '/launch',
    component: lazyLoad('launch'),
  },
  {
    path: '/maintenance',
    name: ROUTE_NAME.maintenance,
    component: lazyLoad('maintenance'),
  },
  {
    // v=1 (the default): the cockfight client. `/cock-fight` is the old path and
    // keeps working.
    path: '/v1',
    alias: '/cock-fight',
    name: ROUTE_NAME.cockFight,
    component: lazyLoad('cock-fight'),
    meta: { title: ROUTE_NAME.cockFight, rules: 'user' },
  },
  {
    // v=2: the Tài Xỉu client. `/tai-xiu` is the old path and keeps working.
    path: '/v2',
    alias: '/tai-xiu',
    name: ROUTE_NAME.taiXiu,
    component: lazyLoad('tai-xiu'),
    meta: { title: ROUTE_NAME.taiXiu, rules: 'user' },
  },
  {
    path: '/404',
    name: ROUTE_NAME.notFound,
    component: lazyLoad('404'),
  },
  {
    path: '/403',
    name: ROUTE_NAME.notAuthorized,
    component: lazyLoad('403'),
  },
  {
    path: '/session-expired',
    name: ROUTE_NAME.sessionExpired,
    component: lazyLoad('session-expired'),
  },
  {
    path: '/video',
    name: ROUTE_NAME.video,
    component: lazyLoad('video'),
  },
  {
    path: '/replay-video',
    name: ROUTE_NAME.videoReplay,
    component: lazyLoad('video-replay'),
    meta: { isPopup: true },
  },
  {
    path: '*',
    name: ROUTE_NAME.notAuthorized,
    component: lazyLoad('404'),
  },
];

function parseQuery(queryString: string) {
  const query: any = {};
  const pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&').filter((str: string) => str);

  // tslint:disable-next-line:prefer-for-of
  for (let i = 0; i < pairs.length; i++) {
    if (pairs[i].indexOf('token=') === 0) {
      const fullToken = pairs[i].split('token=')[1];
      query.token = decodeURIComponent(fullToken);
    } else if (pairs[i].indexOf('auth=') === 0) {
      const fullAuth = pairs[i].split('auth=')[1];
      query.auth = decodeURIComponent(fullAuth);
    } else if (pairs[i].indexOf('competition_id%5B%5D') === 0 || pairs[i].indexOf('competition_id[]') === 0) {
      const pair = pairs[i].split('=');
      if (query[decodeURIComponent(pair[0])]) {
        query[decodeURIComponent(pair[0])].push(pair[1]);
      } else {
        query[decodeURIComponent(pair[0])] = [pair[1]];
      }
    } else {
      const pair = pairs[i].split('=');
      query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
  }
  return !isEmpty(query) ? query : undefined;
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  parseQuery,
});

router.beforeEach(async (to, from, next) => {
  const versionParam = to.query.v ?? to.query.V;
  if (versionParam !== undefined && versionParam !== '') {
    store.commit('general/UPDATE_GENERAL', {
      clientVersion: resolveClientVersion(versionParam),
    });
  }

  if (to.name !== ROUTE_NAME.maintenance) {
    await store.dispatch('general/getMaintenanceStatus');
    const maintenance = store.getters['general/maintenance'];
    if (maintenance.m) {
      next({
        name: ROUTE_NAME.maintenance,
      });
      return;
    }
  }
  
  if (to.meta && to.meta.rules === 'user') {
    const { token } = getItemFromStore('general').general;
    // VALIDATE TOKEN
    if (!token) {
      next({ name: '403' });
      return;
    }

    if (to.name === ROUTE_NAME.taiXiu && !store.getters['general/isClientV2']) {
      next({ name: ROUTE_NAME.cockFight });
      return;
    }

    if (to.name === ROUTE_NAME.cockFight && store.getters['general/isClientV2']) {
      next({ name: ROUTE_NAME.taiXiu });
      return;
    }

    next();
  } else {
    next();
  }
});

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  if (isChunkLoadFailed) {
    window.location.reload();
  } else {
    console.log(error);
  }
});

export default router;
